import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#314467",
      secondary: "#9f9f9f"
    },
    text: {
      primary: "#314467",
      secondary: "#9f9f9f"
    }
  },
  typography: {
    fontFamily: "poppins, sans-serif"
  }
});

export default theme;